<template>
  <div class="start-box">
    <div class="title">DMM GAME PLAYER はお持ちですか？</div>
    <div class="desc">
      このゲームをプレイするためには、DMM GAME
      PLAYERをインストールしておく必要があります。
    </div>
    <div class="btn-arr">
      <div class="item">
        <p class="btn-title">インストール済みの方</p>
        <div v-if="!isLoading" @click="btnStart" class="btn uninstall">
          今すぐプレイ！
        </div>
        <div v-if="isLoading" class="btn btn-loading">
          <img
            src="https://www.dmm.co.jp/images/common/ico/loading.gif"
            alt=""
          /><span>処理中です･･･</span>
        </div>
      </div>
      <div class="item">
        <p class="btn-title">未インストールの方</p>
        <a
          target="_blank"
          href="https://site-gameplayer.dmm.com/gameplayer/game/installer/win/x86/akakuro/cl/general"
        >
          <div class="btn dmmdowload">
            <div>
              <p class="dmm">DMM GAME PLAYER</p>
              <p class="tips">インストール(Windows版)</p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <a
      target="_blank"
      class="dmm-question"
      href="http://www.dmm.com/netgame/top/guide/playerguide_html/=/ch_navi=/"
      >DMM GAME PLAYERとは？</a
    >
  </div>
</template>

<script>
import { systemJudg } from "@/util";
export default {
  data() {
    return {
      showStart: false,
      urlScheme: "#start",
      iframe: "",
      timerInstallCheck: null,
      timerBtnDisabled: null,
      isLoading: false
    };
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    addIframe() {
      this.iframe = document.createElement("iframe");
      this.iframe.style.display = "none";
      document.body.appendChild(this.iframe);
    },
    btnStart() {
		const system = systemJudg();
		if(system === 'system') {
			layer.open({
				content: 'このゲームはPC専用です。',
				time: 2,
				skin: 'msg'
			})
			return false
		} else if(system === 'notwin') {
			layer.open({
				content: 'このゲームはWindows専用です。',
				time: 2,
				skin: 'msg'
			})
			return false
		}
      clearTimeout(this.timerInstallCheck);
      this.isLoading = true;
      this.timerInstallCheck = setTimeout(() => {
        window.removeEventListener("blur", this.onBlur);
      }, 5000);

      window.focus();
      window.addEventListener("blur", this.onBlur);
      this.iframe.src = "dmmgameplayer://akakuro/cl/general";

      clearTimeout(this.timerBtnDisabled);
      this.timerBtnDisabled = setTimeout(() => {
        this.isLoading = false;
      }, 5000);
    },
    onBlur() {
      clearTimeout(this.timerInstallCheck);
    }
  },
  mounted() {
    this.addIframe();
  }
};
</script>

<style lang="scss" scoped>
.start-box {
  // position: absolute;
  // left: 50%;
  // top: 50%;
  // width: 1002px;
  // height: 602px;
  // transform: translate(-50%, -50%);
  // @include bg("dmodal.png");
  text-align: center;

  .title {
    font-size: 36px;
    color: #ffe6aa;
    margin-top: 110px;
  }

  .desc {
    font-size: 20px;
    color: #dde0f7;
    line-height: 32px;
    margin-top: 30px;
  }

  .btn-arr {
    font-size: 28px;
    color: #ffffff;
    text-align: center;
    margin-top: 52px;
    .item {
      display: inline-block;
      vertical-align: top;
      margin: 0 40px;
      a {
        text-decoration: none;
      }
      .btn-title {
        font-size: 28px;
        margin-bottom: 18px;
        color: #dde0f7;
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 316px;
        height: 100px;
        border-radius: 4px;
        cursor: pointer;
        color: #ffffff;
        &.uninstall {
          background: linear-gradient(0deg, #1580cc 0%, #44affb 100%);
          box-shadow: 0px 2px 0px 0px #1b1b1b;
        }
        &.dmmdowload {
          background: linear-gradient(0deg, #e68302 0%, #fea531 100%);
          box-shadow: 0px 2px 0px 0px #1b1b1b;
        }
        &.btn-loading {
          background: #b4e0ff;
          cursor: default;
          span {
            padding-left: 30px;
          }
        }
        .dmm {
          font-size: 26px;
        }
        .tips {
          font-size: 23px;
        }
      }
    }
  }

  .dmm-question {
    font-size: 20px;
    color: #dde0f7;
    margin-top: 60px;
    display: inline-block;
    text-decoration: none;
  }
}
</style>
